import {
  UBCMessage,
  UBCMessageName,
} from '@epicuro-next/state/ubc-communication/core';
import { createAction, props } from '@ngrx/store';
import { BasketUpdateItem } from 'graphql-api/baskets-api-interfaces';

export type UpdateBasketStrategy = 'overwrite' | 'add';

export const updateBasket = createAction(
  '[UBC Basket] Update basket',
  props<
    UBCMessage<
      UBCMessageName.UpdateBasket,
      {
        shops: { [deliveryShop: string]: BasketUpdateItem[] };
        initiatorSource: UBCMessageName;
        updateStrategy?: UpdateBasketStrategy;
      }
    >
  >(),
);

export const updateBasketSuccess = createAction(
  '[UBC Basket] Update basket success',
  props<
    UBCMessage<
      UBCMessageName.UpdateBasketSuccess,
      { source: UBCMessageName; basketId: string }
    >
  >(),
);

export const updateBasketError = createAction(
  '[UBC Basket] Update basket error',
  props<
    UBCMessage<UBCMessageName.UpdateBasketError, { source: UBCMessageName }>
  >(),
);
